export const GLOBAL_SEARCH_DEFAULT_LIMIT = 8
